/**
 * Landscaping Professionals Map Block - Modern JavaScript
 * This file handles intersection observer for lazy loading
 * The actual Google Maps initialization is handled in the PHP file
 */

'use strict';

jQuery(document).ready(function ($) {
  // Intersection Observer for lazy loading when block comes into view
  // This ensures the map only initializes when the user scrolls to it
  var observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        var mapBlock = entry.target;

        // Check if map has already been initialized
        if (mapBlock.dataset.mapInitialized) {
          observer.unobserve(mapBlock);
          return;
        }

        // Trigger map initialization if the PHP script hasn't already done so
        if (window.landscapingProfessionalsData && !window.landscapingProfessionalsMap) {
          // The map initialization will be handled by the PHP script
          // This observer is just for performance optimization
          mapBlock.dataset.mapInitialized = 'true';
        }
        observer.unobserve(mapBlock); // Stop observing once initialized
      }
    });
  }, {
    rootMargin: '50px 0px',
    // Start loading 50px before the element comes into view
    threshold: 0.1 // Trigger when 10% of the element is visible
  });

  // Observe elements with the Landscaping Professionals block class
  document.querySelectorAll('.landscaping-professionals-map-block').forEach(function (mapBlock) {
    observer.observe(mapBlock);
  });

  // Additional functionality for enhanced user experience
  var searchInput = document.getElementById('lfr-city');
  var form = document.getElementById('lfr-form');
  if (searchInput && form) {
    // Add loading state to search button
    var submitButton = form.querySelector('button[type="submit"]');
    form.addEventListener('submit', function () {
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Searching...';

        // Re-enable button after a short delay
        setTimeout(function () {
          submitButton.disabled = false;
          submitButton.textContent = 'Search';
        }, 2000);
      }
    });

    // Clear search results when user starts typing
    searchInput.addEventListener('input', function () {
      var positiveResults = document.querySelector('.lfr__search-results__positive');
      var negativeResults = document.querySelector('.lfr__search-results__negative');
      if (positiveResults) positiveResults.classList.remove('d-block');
      if (negativeResults) negativeResults.style.display = 'none';
    });
  }
});